module.exports = __webpack_public_path__ + "static/img/15.4187d85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/15.png
// module id = tIrz
// module chunks = 0